//Roles
import { ADMIN, PROV, CONTROL} from './roles'

//Habilitados para ver solapa nav de productos.
export const VER_PRODUCTOS = [ADMIN];
//Habilitados para ver solapa nav de usuario.
export const VER_USUARIOS = [ADMIN];
//Habilitados para reenviar un comprobante desde la lista de comprobantes.
export const REENVIO_MOVIPORT = [ADMIN, CONTROL];
//Habilitados para proveedores.
export const VER_PROVEEDORES = [ADMIN];
//Habilitados para proveedores.
export const ACTUALIZAR_MOVIMIENTOS_PROVEEDOR = [ADMIN, CONTROL];
//Habilitados para valid datos.
export const VER_VALID_DATOS = [PROV];
//Habilitados para grupos.
export const VER_GRUPOS = [ADMIN];
//Habilitados para modifcar estado de comprobante.
export const MODIFICA_ESTADO_COMPROBANTE = [ADMIN, CONTROL];
//Habilitados para editar comprobante.
export const EDITA_COMPROBANTE = [ADMIN, CONTROL];
//Habilitados para editar y ver notas privadas.
export const EDITA_Y_VISUALIZA_NOTAS_PRIVADAS_COMPROBANTE = [ADMIN, CONTROL];
//Habilitados para editar y ver notas privadas.
export const EDITA_NOTAS_PRIVADAS_SOLICITUD = [ADMIN, CONTROL];
//Habilitados para editar solicitud de ajuste.
export const EDITA_SOLICITUD = [PROV];
//Habilitados para modifcar estado de solicitud de ajuste.
export const MODIFICA_ESTADO_SOLICITUD = [ADMIN, CONTROL];
//Habilitados para modificar grupos de comprobantes.
export const MODIFICA_GRUPOS_COMPROBANTES = [ADMIN, CONTROL];
//Habilitados para grupos.
export const VER_ABMS = [ADMIN];
//Habilitados para ver configuración global.
export const VER_CONFIG_GLOBAL = [ADMIN];
//Habilitados para guardar comprobantes sin validación de archivo adjunto
export const GUARDAR_TDOCS_SIN_VALIDACION = [ADMIN, CONTROL];
//Habilitados para modificar estado de comprobante rechazado
export const MODIFICA_COMPROBANTE_ESTADO_RECHAZADO = [ADMIN, CONTROL];
